var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20,6h-8l-2-2H4C2.9,4,2,4.9,2,6v12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V8C22,6.9,21.1,6,20,6z M21,18 c0.1,0.5-0.3,0.9-0.8,1c-0.1,0-0.1,0-0.2,0H4c-0.5,0.1-0.9-0.3-1-0.8c0-0.1,0-0.1,0-0.2V6C2.9,5.5,3.3,5.1,3.8,5C3.9,5,3.9,5,4,5 h5.6l1.7,1.7L11.6,7H20c0.5-0.1,0.9,0.3,1,0.8c0,0.1,0,0.1,0,0.2V18z M4,8h16v1H4V8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItFolder);
export default __webpack_public_path__ + "static/media/it-folder.7c9d99ff.svg";
export { ForwardRef as ReactComponent };